const saveOrder = {
    namespaced: true,
    state: {
        contactInfo: {
            id: 0,
            memberId: 0,
            areaId: 0,
            areaName: '',
            contact: '',
            contactPhone: '',
            contactAddress: '',
            isDefault: false,
            address: '',
            goodAttributeDetial: {}
        },
        isRefresh: true,
        skuData: JSON.parse(sessionStorage.getItem('sku')) || {
            // 商品 id
            goodsId: '0',
            // 留言信息
            messages: {},
            // 另一种格式的留言，key 不同
            cartMessages: {},
            // 选择的商品数量
            selectedNum: 1,
            // 选择的 sku 组合
            selectedSkuComb: {}
        }
    },
    mutations: {
        isRes(state, re) {
            state.isRefresh = re;
        },
        setContactInfo(state, data) {
            state.contactInfo = data;
            // state.contactInfo.contact = data.contact;
            // state.contactInfo.contactPhone = data.contactPhone;
            // state.contactInfo.address = data.address;
            // console.log('state.contactInfo：%@', state.contactInfo);
        },
        setSkuData(state, sku) {
            sessionStorage.setItem('sku', JSON.stringify(sku));
            state.skuData = sku;
        }
    },
    actions: {
        async getContactInfo({state}, payload) {
            if (state.isRefresh === false) {
                return;
            }
            const rep = await abp.ajax.get('api/services/app/ContactInformation/GetContactInformationByMemberId?MemberId=' + payload.data.id);
            if (rep) {
                state.contactInfo = rep.data.result;
                if (rep.data.result) {
                    state.contactInfo.address = rep.data.result.areaName + rep.data.result.contactAddress;
                }
            }
        }
    }
};
export default saveOrder;
